import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallRampUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3.334 10.594 3.38-3.38c.26-.261.683-.261.943 0L9.084 8.64c.26.26.683.26.943 0L14 4.668"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.222 4.668H14v1.778"
    />
  </svg>
);
export default SvgSmallRampUp;
